import { render, staticRenderFns } from "./contentBannerRecycle.vue?vue&type=template&id=37dbe6a8&"
import script from "./contentBannerRecycle.vue?vue&type=script&lang=js&"
export * from "./contentBannerRecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports